export interface TimestampNote {
  timestamp: string
  note: string
}

/** Normalize notes from JSONB, JSON string, or legacy plain text */
export function parseEntityNotes(raw: unknown): TimestampNote[] {
  if (raw == null) return []

  if (Array.isArray(raw)) {
    return raw
      .map((item) => {
        if (!item || typeof item !== 'object') return null
        const note = String((item as { note?: unknown }).note ?? '').trim()
        if (!note) return null
        const timestamp =
          typeof (item as { timestamp?: unknown }).timestamp === 'string'
            ? (item as { timestamp: string }).timestamp
            : new Date(0).toISOString()
        return { timestamp, note }
      })
      .filter((item): item is TimestampNote => item != null)
  }

  if (typeof raw === 'string') {
    const trimmed = raw.trim()
    if (!trimmed) return []
    if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
      try {
        return parseEntityNotes(JSON.parse(trimmed))
      } catch {
        return [{ timestamp: new Date(0).toISOString(), note: trimmed }]
      }
    }
    return [{ timestamp: new Date(0).toISOString(), note: trimmed }]
  }

  return []
}
